import { render, staticRenderFns } from "./FeedBackAtividadeMaisGostou.vue?vue&type=template&id=2e74650f&scoped=true"
import script from "./FeedBackAtividadeMaisGostou.vue?vue&type=script&lang=js"
export * from "./FeedBackAtividadeMaisGostou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74650f",
  null
  
)

export default component.exports